import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getTrialList } from '../../dashboard/components/currentPlan/store/thunk'
import { selectUserType } from '../../layout/store/slice'
import { USER_TYPE } from '../../utils/authorization'
import { TextLink } from '../html/TextLink'
import { Element } from '../html/element'
import './i18n'

const FIRST_PAGE = 1
const DEFAULT_PAGE_SIZE = 50

export const NotPermissionAccess = ({ setIsShowViewPlan, setShowTrial }) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const locale = useSelector((state) => state.i18n.locale)

  const viewPlan = (e) => {
    e?.stopPropagation()
    setIsShowViewPlan(true)
  }

  const viewTrial = () => {
    setShowTrial(true)
  }

  useEffect(() => {
    if (userType.userTypeId === USER_TYPE.TRIAL) {
      dispatch(
        getTrialList({
          Page: FIRST_PAGE,
          PageSize: DEFAULT_PAGE_SIZE,
        }),
      )
    }
  }, [locale])

  return (
    <>
      {userType.userTypeId === USER_TYPE.TRIAL && (
        <Element style={{ color: '#9C9C9C', fontStyle: 'italic' }}>
          <TextLink
            id="common_notPermissionAccess_notPermissionContent"
            value={'common.notPermissionAccess.TRIAL_NOT_PERMISSION_CONTENT'}
            labelLink={'common.notPermissionAccess.HERE'}
            onClick={viewTrial}
          />
        </Element>
      )}
      <Element style={{ color: '#9C9C9C', fontStyle: 'italic' }}>
        <TextLink
          id="common_notPermissionAccess_upgradeContent"
          value={
            'common.notPermissionAccess.' +
            (userType.userTypeId === USER_TYPE.TRIAL
              ? 'TRIAL_UPGRADE_CONTENT'
              : 'UPGRADE_CONTENT')
          }
          labelLink={'common.notPermissionAccess.UPGRADE'}
          onClick={viewPlan}
        />
      </Element>
    </>
  )
}
